import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import genererGuid from '@/services/general/genererGuid';

const LIBELLE_SANS_SECTEUR = 'Sans secteur d\'activité';

function creerNoeud(data) {
  return {
    data,
    children: [],
    selected: false,
    openSecteur: false,
    id: data.id || data.num,
    libelle: data.nomCommercial || data.libelle,
  };
}

function trierParLibelle(a, b) {
  return a.libelle.toLowerCase().localeCompare(b.libelle.toLowerCase());
}

function getMarqueConcurrent(tiers) {
  const tiersMarque = tiers.tiersParent?.tiersMarques?.[0] || tiers.tiersMarques?.[0];
  return tiersMarque?.marque?.libelle || '';
}

function normaliserConcurrent(concurrent) {
  return {
    id: concurrent.id,
    urlLogo: concurrent.urlLogo,
    libelle: concurrent.nomCommercial,
    marque: getMarqueConcurrent(concurrent),
    secteurActiviteId: get(concurrent, 'tiersParent.secteurActiviteId', null) || concurrent.secteurActiviteId,
    secteurActivite: get(concurrent, 'tiersParent.secteurActivite', null) || concurrent.secteurActivite,
    coordonnees: {
      lat: get(concurrent, 'adressePostale.latitude', 0),
      lng: get(concurrent, 'adressePostale.longitude', 0),
    },
  };
}

function creerEnfantsMarques(concurrentsSecteur) {
  const avecMarque = concurrentsSecteur.filter(c => c.marque && c.marque !== '');
  const sansMarque = concurrentsSecteur.filter(c => !c.marque || c.marque === '');

  const marques = uniqBy(avecMarque.map(c => ({ libelle: c.marque.trim(), id: genererGuid() })), 'libelle')
    .map(creerNoeud)
    .sort(trierParLibelle);

  marques.forEach(noeudMarque => {
    noeudMarque.children = avecMarque
      .filter(c => c.marque.trim() === noeudMarque.libelle)
      .map(creerNoeud)
      .sort(trierParLibelle);
  });

  const noeudsSansMarque = sansMarque
    .map(c => ({ ...creerNoeud(c), isPdv: true }))
    .sort(trierParLibelle);

  return [...marques, ...noeudsSansMarque];
}

function selectionnerSecteurCourant(noeuds, secteurActiviteId) {
  const index = noeuds.findIndex(n => n.id === secteurActiviteId);
  if (index === -1) return;

  const secteurCourant = noeuds[index];
  secteurCourant.selected = true;
  secteurCourant.openSecteur = true;
  secteurCourant.children.forEach(enfant => {
    enfant.selected = true;
    enfant.children.forEach(sousEnfant => {
      sousEnfant.selected = true;
    });
  });

  noeuds.splice(index, 1);
  noeuds.unshift(secteurCourant);
}

function creerNoeudSansSecteur(concurrentsSansSecteur) {
  return {
    data: { id: 'sans-secteur', libelle: LIBELLE_SANS_SECTEUR },
    id: 'sans-secteur',
    libelle: LIBELLE_SANS_SECTEUR,
    selected: false,
    openSecteur: false,
    children: concurrentsSansSecteur
      .map(c => ({ ...creerNoeud(c), isPdv: true }))
      .sort(trierParLibelle),
  };
}

function formatageConcurrents(pdv, concurrents) {
  const concurrentsNormalises = concurrents.map(normaliserConcurrent);
  const concurrentsAvecSecteur = concurrentsNormalises.filter(c => c.secteurActiviteId);
  const concurrentsSansSecteur = concurrentsNormalises.filter(c => !c.secteurActiviteId);

  const secteursActivites = uniqBy(
    concurrentsAvecSecteur.map(c => c.secteurActivite).filter(Boolean),
    'id'
  );

  const noeuds = secteursActivites
    .map(secteur => ({
      ...creerNoeud(secteur),
      children: creerEnfantsMarques(concurrentsAvecSecteur.filter(c => c.secteurActiviteId === secteur.id)),
    }))
    .filter(n => n.children.length);

  if (concurrentsSansSecteur.length) {
    noeuds.push(creerNoeudSansSecteur(concurrentsSansSecteur));
  }

  noeuds.sort(trierParLibelle);

  if (pdv.secteurActiviteId) {
    selectionnerSecteurCourant(noeuds, pdv.secteurActiviteId);
  }

  return noeuds;
}

export default function genererConcurrents(pdv, concurrents) {
  const data = formatageConcurrents(pdv, concurrents);
  const nbreReelConcurrent = data.reduce((total, secteur) =>
    total + secteur.children.reduce((sous, enfant) =>
      sous + (enfant.children.length || 1), 0
    ), 0
  );
  return { data, nbreReelConcurrent };
}
